import { Grid, Skeleton, Typography } from '@mui/material';
import { Colors } from '@vabembarqueja/embarque-ja-shared-components';
import { useEffect, useState } from 'react';

import CardExtrato from 'src/app/components/CardExtrato';
import { Extrato } from 'src/models/Extrato';
import { PagamentoService } from 'src/services';

export const ExibirConsumoPosPago = () => {
  const [items, setItems] = useState<Extrato[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    PagamentoService.getTransacoesPosPago()
      .then(setItems)
      .finally(() => setLoading(false));
  }, []);

  const sorted = items
    .map((item) => {
      const [mes, ano] = item.mesAno.split('-');
      return { ...item, mes: Number(mes), ano: Number(ano) };
    })
    .sort((a, b) => b.ano - a.ano || b.mes - a.mes);

  return (
    <>
      {loading && (
        <Grid container gap={2} py={2} px={2}>
          {Array(5)
            .fill(1)
            .map((_item, index) => index)
            .map((value) => (
              <Skeleton key={value} variant="rounded" width="100%" height={70} />
            ))}
        </Grid>
      )}

      <Grid item xs={12}>
        {sorted.map((transacoes) => {
          return (
            <div key={transacoes.mesAno}>
              <CardExtrato mesAno={transacoes.mesAno} valorPeriodo={transacoes.valorPeriodo} />
            </div>
          );
        })}

        {sorted.length === 0 && !loading && (
          <Typography variant="h6" color={Colors.primary.main}>
            Não existem transações referentes a este período para serem exibidas.
          </Typography>
        )}
      </Grid>
    </>
  );
};
